module.exports = __webpack_public_path__ + "mariah-2.140a2396.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/cutouts/mariah-2.svg
 ** module id = 386
 ** module chunks = 0
 **/